export default "https://static-website.miro.com/miro-site-lp-build-assets/_next/static/chunks/fonts/spoof-medium-2a6ce62bb199b3701cb3ceb63f5d9559.woff";